module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('headerTop'), _vm._v(" "), _c('div', {
    staticClass: "swiperImg",
    style: ({
      backgroundImage: 'url(' + _vm.$index.addurl(_vm.img) + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "center page-content flexbetween",
    style: ({
      animation: _vm.animation
    })
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "leftD"
  }, _vm._l((_vm.aboutLists), function(item, index) {
    return _c('div', {
      staticClass: "leftD_child",
      on: {
        "click": function($event) {
          return _vm.todetail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "child",
    domProps: {
      "innerHTML": _vm._s(_vm.contents)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prosss"
  }, [_c('div', {
    staticClass: "line"
  }, _vm._l((_vm.list.length), function(item) {
    return _c('div', {
      staticClass: "child"
    })
  }), 0), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "list flexaround"
    }, [_c('div', {
      staticClass: "left flexleft"
    }, [_c('div', {
      staticClass: "txt",
      class: index % 2 != 0 ? 'leftCol' : ''
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "time",
      class: index % 2 != 0 ? 'leftCol' : ''
    }, [_vm._v(_vm._s(item.date))])]), _vm._v(" "), _c('div', {
      staticClass: "right flexleft"
    }, [_c('div', {
      staticClass: "time",
      class: index % 2 == 0 ? 'leftCol' : ''
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('div', {
      staticClass: "txt",
      class: index % 2 == 0 ? 'leftCol' : ''
    }, [_vm._v(_vm._s(item.title))])])])
  })], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-413d15ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/jrService/fzLiucheng.vue
// module id = 1088
// module chunks = 1